import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import { ParentContext } from "global/cnr/contexts/ParentContext";

export default function ErrorBoundaryWithNavigate(props) {
  const navigate = useNavigate();
  const parentContext = useContext(ParentContext); // ✅ works here
  return (
    <ErrorBoundary
      {...props}
      parentContext={parentContext}
      handleCancel={() => navigate(-1)} // 👈 override handleCancel
    />
  );
}
